module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAABVUlEQVR4Xu2X0Q3CMAxEnbX4gVHKHv1lDmATvmCsVJEaqapoKa3js+Trf2Lf812sJgn+peD6hQDogOAEGIHgBuAjyAgwAsEJMALBDcAtwAgwAsEJMALBDcAtwAgwAsEJQCNwuuVOspzffbqi5gADMIq/j8IfKAgQADPxdfgQCOYAFsTDIJgC+CEeAsEMwEbx5hBMACyJzyLPlOQlWepjOF0GJm9CcwBr4j996oriFXc0h9AUwBbxdeQoCM0A/CMeCaEJgD3iURDUARwRj4CgCkBDvDUENQCa4i0hNAVQ9nxddXv/9r6B1bi39qMGYL7PNZucQtC8t/SsCqBCyFkuRyc/d0yB0OJedQB7rY46RwAo8l7q0gFeJoHqgw5AkfdSlw7wMglUH3QAiryXunSAl0mg+qADUOS91KUDvEwC1QcdgCLvpS4d4GUSqD7oABR5L3XDO2AAuHOwQZQnKoMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/community/hover-angle-up.png
// module id = Mce8
// module chunks = 15